import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EnvisiaObject, EnvisiaObjects, Lister} from '../../common/wrapper.models';
import {Akquise, AkquiseForm} from './akquise.models';
import {EnvisiaLocation} from '../../common/location/envisia-location';
import {ListService} from '../../common/search/search.service';
import {map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable({providedIn: 'root'})
export class AkquiseService implements ListService<Akquise> {

  constructor(private http: HttpClient) {
  }

  list(query?: any): Observable<Lister<Akquise>> {
    return this.http.get<Lister<Akquise>>(
      `${environment.apiv4uri}akquise`,
      {params: EnvisiaLocation.httpParams(query)}
    );
  }

  userList(): Observable<string[]> {
    return this.http.get<EnvisiaObjects<string>>(`${environment.apiv4uri}akquise/user/list`).pipe(map(obj => obj.objects));
  }

  edit(id: number, form: AkquiseForm): Observable<Akquise> {
    return this.http.put<EnvisiaObject<Akquise>>(`${environment.apiv4uri}akquise/${id}`, form).pipe(map(obj => obj.object));
  }

  create(customerId: number, form: AkquiseForm): Observable<Akquise> {
    return this.http.post<EnvisiaObject<Akquise>>(
      `${environment.apiv4uri}akquise?customer_id=${customerId}`,
      form
    ).pipe(map(obj => obj.object));
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiv4uri}akquise/delete/${id}`).pipe(map(() => {}));
  }

}
